<template>
  <b-modal
    :visible="value"
    :dialog-class="`ok-modal ${dialogClass} ${scrollable ? 'scrollable' : null}`"
    cancel-variant="secondary"
    centered
    :size="size"
    hide-footer
    hide-header
    hide-header-close
    :no-close-on-backdrop="noCloseOnBackdrop"
    ignore-enforce-focus-selector=".ck-balloon-panel, .ck-body-wrapper"
    @change="$emit('change', $event)"
  >

    <div class="ok-modal-title">
      <div>
        <slot name="title">
          <span :class="titleClass">{{ title }}</span>
        </slot>
      </div>
      <div>
        <slot name="close">
          <b-button
            v-if="!hideClose"
            class="btn-icon"
            variant="link"
            @click="$emit('change', false)"
          >
            <feather-icon
              icon="XIcon"
              class="text-secondary"
              size="14"
            />
          </b-button>
        </slot>
      </div>
    </div>

    <vue-perfect-scrollbar
      v-if="scrollable"
      class="ok-modal-content"
    >
      <slot />
    </vue-perfect-scrollbar>
    <div
      v-else
      class="ok-modal-content"
    >
      <slot />
    </div>

    <div class="ok-modal-footer">
      <slot name="actions" />
    </div>
  </b-modal>
</template>

<script>
import { BModal, BButton } from 'bootstrap-vue'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'

export default {
  name: 'OkModal',
  components: {
    BModal, BButton, VuePerfectScrollbar,
  },
  props: {
    title: {
      default: '',
    },
    value: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: 'sm',
    },
    dialogClass: {
      type: String,
      default: '',
    },
    titleClass: {
      type: String,
      default: '',
    },
    noCloseOnBackdrop: {
      type: Boolean,
      default: true,
    },
    scrollable: {
      type: Boolean,
      default: false,
    },
    hideClose: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
  },
}
</script>

<style lang="scss">
.ok-modal {
  .col-form-label, .checkbox-list {
    font-size: 14px;
  }

  .modal-body {
    padding-bottom: 20px;
  }

  &.scrollable {
    .ok-modal-content {
      max-height: 75vh;
    }
  }

  .ok-modal-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    border-bottom: solid 1px #e8e7eb;
    margin-bottom: 13.5px;

    span {
      font-size: 16px;
      font-weight: 600;
      line-height: 1.29;
      color: var(--purple);
    }
  }

  .ok-modal-footer {
    margin-top: 15px;

    .btn {
      font-size: 14px!important;
      font-weight: 600!important;
      line-height: 1.29!important;
    }
  }
}
</style>
